import React, {useContext, useState, useEffect} from 'react';
import {Valoracion} from './Valoracion';
import './stylesMarketplace.css';
import {useNavigate} from 'react-router-dom';
import {useSessionStore} from '../../hooks/useSessionStore';
import {UsuarioContext} from '../../contexts/UsuarioContext';
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';

/**
 * It returns a div with a class name of "empresa-empresa-body-market-place" that contains a div with a
 * class name of "overlap-group-63" that contains an image with a class name of
 * "imagen-empresa-empresa-bodymarket-place" that has a source of
 * "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse3.mm.bing.net%2Fth%3Fid%3DOIP.ug-mm0XA3fyNCR5o8VcQ5gHaE7%26pid%3DApi&f=1",
 * a div with a class name of "nombre-empresa-1 poppins-medium-black-15-3px" that contains the text
 * "Empresa" and a Valoracion component that
 * @returns A div with a class name of empresa-empresa-body-market-place.
 */
function EmpresaEmpresaBodyMarketPlace(props) {
	/* Destructuring the props object. */
	const {numEmpresa, empresa, buscarNombre} = props;

	/* A hook that allows to navigate between routes. */
	const navigate = useNavigate();
	const [Usuario, setUsuario] = useSessionStore(UsuarioContext);
	const goToEmpresa = () => {
		navigate('/perfilAgencia');
	};
	const useStyles = makeStyles({
		root: {
			'border-radius': 10,
		},
	});
	const classes = useStyles();

	const abrirPerfilEmpresa = (id) => {
		if (Usuario.tipo === 'usuarioNormal') {
			axios({
				/* Sending a post request to the server. */
				method: 'post',
				url: window.ipdirection + 'logs?logstream=abrirPerfilEmpresa',
				headers: {
					Authorization: 'Bearer ' + Usuario.access,
				},
				data: {
					usuario: Usuario.cliente.usuario.id,
					idempresa: id,
					accion: 'abrirPerfilEmpresa',
				},
			})
				.then((response) => {})
				.catch((error) => {});
		}

		navigate('/perfilAgencia/' + id);
	};

	return (
		<Card
			className={classes.root}
			onClick={() => abrirPerfilEmpresa(empresa.id)}
		>
			<CardActionArea>
				<CardMedia
					component='img'
					alt='Contemplative Reptile'
					Height='240'
					image={empresa.img}
					title='Contemplative Reptile'
				/>
				<CardContent>
					<Typography
						gutterBottom
						variant='h5'
						component='h2'
					>
						{empresa.nombreEmpresa}
					</Typography>
					<Valoracion empresaId={empresa.id} />
					<Typography
						variant='body2'
						color='textSecondary'
						component='p'
					>
						{empresa.descripcionEmpresa}
					</Typography>
				</CardContent>
			</CardActionArea>
		</Card>
	);
}

export default EmpresaEmpresaBodyMarketPlace;
